import { Body, Controller, Post } from '@nestjs/common';
import { Cron } from '@nestjs/schedule';
import { ApiBody } from '@nestjs/swagger';
import { ErrorResponse, GlobalResponseObject } from '@shahi-analytics/backend-utils';
import { MigrationService } from './migration.service';
import { UnitDateHourRequest } from './models/unit-date-hour.request';
import { MigrationHelperService } from './migration-helper.service';
import { MigrationTriggerService } from './migration-trigger.service';
import { TempUnitModel } from './models/plan/temp-unit.model';
import { LineTargetEffRequest } from './models/line-target-eff.request';
import { StyleTargetEffRequest } from '@shahi-analytics/shared-models';

@Controller('migration')
export class MigrationController {
  constructor(
    private readonly migService: MigrationService,
    private readonly migHelperService: MigrationHelperService,
    private readonly migTriggerService: MigrationTriggerService
  ) { }

  // @Cron('0 5 * * * *') // At every hour at the 5th minute
  async callLineHourMigraiton() {
    let date = new Date();
    const currentDate = date.toJSON().slice(0, 10);
    const hour = date.getHours() - 1; // -1 beacuse we have to sync data for the pre hour when the job runs in the current hour
    console.log(currentDate);
    console.log(hour);
    const req = new UnitDateHourRequest();
    req.hour = hour;
    req.date = currentDate;
    // check all the pre requisites
    await this.triggerHourMigrationForAllUnits(req);
  }

  @ApiBody({ type: UnitDateHourRequest })
  @Post('/triggerHourMigrationForAllUnits')
  async triggerHourMigrationForAllUnits(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      // let currentDate = req.date;
      return await this.migTriggerService.triggerHourMigrationForAllUnits(req.hour, req.date);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.toString());
    }
  }

  @ApiBody({ type: UnitDateHourRequest })
  @Post('/triggerMasterDataHourMigrationForSpecificLine')
  async triggerMasterDataHourMigrationForSpecificLine(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      let currentDate = new Date().toJSON().slice(0, 10);
      return await this.migTriggerService.triggerMasterDataHourMigrationForSpecificLine(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.toString());
    }
  }

  @ApiBody({ type: UnitDateHourRequest })
  @Post('/triggerTrackingDataHourMigrationForSpecificLine')
  async triggerTrackingDataHourMigrationForSpecificLine(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.migTriggerService.triggerTrackingDataHourMigrationForSpecificLine(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.toString());
    }
  }

  // @Cron('0 15 * * * *') // At every hour at the 15th minute
  async callLinePlanMigraiton() {
    let date = new Date();
    const currentDate = date.toJSON().slice(0, 10);
    const req = new UnitDateHourRequest();
    req.date = currentDate;
    // check all the pre requisites
    // await this.migService.createPlanOld(req);
  }

  /**
   * Tested
   * @param req 
   * @returns 
   */
  // @Cron('')
  @ApiBody({ type: UnitDateHourRequest })
  @Post('/createLines')
  async createLines(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.migService.createLines(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.toString());
    }
  }

  /**
   * Tested
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitDateHourRequest })
  @Post('/createWorkstations')
  async createWorkstations(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.migService.createWorkstations(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.message);
    }
  }

  /**
   * Tested
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitDateHourRequest })
  @Post('/createOperators')
  async createOperators(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.migService.createOperators(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.message);
    }
  }

  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitDateHourRequest })
  @Post('/createOperations')
  async createOperations(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.migService.createOperations(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.message);
    }
  }

  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitDateHourRequest })
  @Post('/createStylesAndStyleOperations')
  async createStylesAndStyleOperations(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.migService.createStylesAndStyleOperations(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.message);
    }
  }

  /**
   * 
   * @param req 
   * @returns `
   */
  @ApiBody({ type: UnitDateHourRequest })
  @Post('/createStylesAndStyleOperationsForAllLinesInUnit')
  async createStylesAndStyleOperationsForAllLinesInUnit(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.migService.createStylesAndStyleOperationsForAllLinesInUnit(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.message);
    }
  }

  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitDateHourRequest })
  @Post('/createLineActualDayTrack')
  async createLineActualDayTrack(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.migService.createLineActualDayTrack(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.message);
    }
  }

  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitDateHourRequest })
  @Post('/createLineDowntime')
  async createLineDowntime(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.migService.createLineDowntime(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.message);
    }
  }

  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitDateHourRequest })
  @Post('/createReasons')
  async createReasons(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.migService.createReasons(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.message);
    }
  }

  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitDateHourRequest })
  @Post('/createOperatorEfficiency')
  async createOperatorEfficiency(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.migService.createOperatorEfficiency(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.message);
    }
  }

  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitDateHourRequest })
  @Post('/createLineEfficiency')
  async createLineEfficiency(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.migService.createLineEfficiency(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.message);
    }
  }

  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({ type: [LineTargetEffRequest] })
  @Post('/saveLineTargetEfficiency')
  async saveLineTargetEfficiency(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.migService.saveLineTargetEfficiency(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.message);
    }
  }

  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({ type: StyleTargetEffRequest })
  @Post('/saveStyleTargetEfficiency')
  async saveStyleTargetEfficiency(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.migService.saveStyleTargetEfficiency(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.message);
    }
  }



  /**
   * 
   * @param req 
   * @returns 
   */
  @ApiBody({ type: UnitDateHourRequest })
  @Post('/createPlanOld')
  async createPlanOld(@Body() req: any): Promise<GlobalResponseObject> {
    try {
      return await this.migService.createPlanOld(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.message);
    }
  }

  @ApiBody({ type: UnitDateHourRequest })
  @Post('/getPlantSubstitutingHour')
  async getPlantSubstitutingHour(@Body() req: any): Promise<any> {
    try {
      return await this.migService.getPlantSubstitutingHour(req.hour, req.unit, req.date);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.message);
    }
  }

  @ApiBody({ type: UnitDateHourRequest })
  @Post('/getPlanTemplate')
  async getPlanTemplate(@Body() req: any): Promise<any> {
    try {
      return await this.migService.getPlanTemplate(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.message);
    }
  }

  @ApiBody({ type: [TempUnitModel] })
  @Post('/saveManualPlan')
  async saveManualPlan(@Body() req: any): Promise<any> {
    try {
      return await this.migService.saveManualPlan(req);
    } catch (error) {
      return new GlobalResponseObject(false, 0, error.message);
    }
  }
}